import React from 'react';
import FocusLock from 'react-focus-lock';
import { FaTimes } from 'react-icons/fa';
import { useModalStore } from 'src/hooks/useStore';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint, modalZIndex } from 'src/styles/globalStyle';
import { scrollbarStyle } from 'src/styles/scrollbar';

const Wrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: ${modalZIndex};
  align-items: center;
  justify-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(39, 38, 38, 0.7);
`;
const Content = styled.div`
  background-color: ${colors.white};
  width: 628px;
  margin: auto;
  border-radius: 8px;
  overflow: auto;
  ${scrollbarStyle}

  @media (max-width: ${mobilePoint}) {
    width: 80%;
    max-height: 90%;
  }
`;
const Header = styled.div<{ isHide?: boolean }>`
  width: 100%;
  height: 64px;
  background-color: ${colors.primaryBlue_500};
  display: ${(prop) => {
    return prop.isHide ? 'none' : 'flex';
  }};
  align-items: center;
  color: ${colors.white};
  justify-content: space-between;
  padding: 0 24px 0px 40px;
`;
const HeaderTitle = styled.div<{ isHide?: boolean }>`
  font-size: 20px;
  font-family: NotoSansTC-Bold;
  cursor: default;
  display: ${(prop) => {
    return prop.isHide ? 'none' : 'flex';
  }};
`;
const CloseIcon = styled.div`
  cursor: pointer;
`;

interface IProps {
  title?: string;
  width?: string;
  children: React.ReactNode;
  isAlert?: boolean;
}

const Modal: React.FC<IProps> = ({ title, width, children, isAlert }) => {
  const closeModal = useModalStore((state) => state.closeModal);
  
  // 處理鍵盤觸發（Enter 或 Space）
  const handleKeyDown = (e: React.KeyboardEvent) => {
  	if (e.key === 'Enter' || e.key === ' ') {
  		e.preventDefault(); // 防止 Space 鍵捲動頁面
  		closeModal();
      }
  };
  
  return (
    <Wrapper>
      <Content style={{ width: width || '' }}>
	  <FocusLock returnFocus>
        <Header isHide={isAlert}>
          <HeaderTitle isHide={isAlert}>{title}</HeaderTitle>
          <CloseIcon aria-label="關閉" tabIndex={0} role="button" onKeyDown={handleKeyDown} onClick={() => closeModal()} >
            <FaTimes size={25} />
          </CloseIcon>
        </Header>
        {children}
	  </FocusLock>
      </Content>
    </Wrapper>
  );
};

export default Modal;
